const en = {
  nav: {
    home: "Home",
    uploads: "Received invoices",
    invoices: "Invoices",
    sales: "Sales",
    suppliers: "Suppliers",
    clients: "Clients",
    projects: "Projects",
    intervenants: "Workers",
    reconciliation: "Reconciliation",
    billing: "Billing",
    team: "Team",
    audit: "Audit log",
    reminderRules: "Reminder rules",
    reminderTemplates: "Reminder templates",
    company: "Company",
    products: "Products",
  },
  topbar: {
    tenant: "Tenant",
    chooseTenant: "— choose —",
    logout: "Log out",
  },
  common: {
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    search: "Search",
    loading: "Loading…",
    noData: "No data",
    actions: "Actions",
    reset: "Reset",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    country: "Country",
    notes: "Notes",
    total: "Total",
    status: "Status",
    date: "Date",
    amount: "Amount",
    year: "Year",
    month: "Month",
    allYears: "All",
    allMonths: "All",
    currency: "Currency",
    reference: "Reference",
    download: "Download",
    paid: "Paid",
    pending: "Pending",
    collected: "Collected",
    revenue: "Total revenue",
    invoices: "Invoices",
    client: "Client",
    project: "Project",
    intervenant: "Worker",
    description: "Description",
    role: "Role",
    active: "Active",
    inactive: "Inactive",
    add: "Add",
    close: "Close",
    previous: "Previous",
    next: "Next",
    noInvoices: "No invoices",
    error: "Error",
    unknownError: "Unknown error",
  },
  status: {
    draft: "Draft",
    issued: "Issued",
    partial: "Partial",
    paid: "Paid",
    overdue: "Overdue",
    cancelled: "Cancelled",
  },
  dashboard: {
    loading: "Loading dashboard",
    errorLoad: "Failed to load dashboard",
    kpiPending: "Pending",
    kpiPendingHint: "Outstanding amount (issued, unpaid invoices)",
    kpiOverdue: "Overdue",
    kpiOverdueHint: "Subset of pending invoices past their due date",
    kpiCollected: "Collected this month",
    kpiCollectedHint: "Sum of payments recorded this month",
    activityTitle: "Business activity",
    activitySubtitle: "Total invoiced per month (last 12 months)",
    activityBilled: "Invoiced (excl. tax)",
    cashflowTitle: "Cash flow",
    cashflowSubtitle: "Collected vs. due per month",
    cashflowDue: "Due",
    cashflowCollected: "Collected",
    recentInvoices: "Recent invoices",
    colRef: "Ref.",
    colClient: "Client",
    colProject: "Project",
    colIntervenant: "Worker",
    colDueDate: "Due date",
    colAmountHT: "Amount (excl. tax)",
    colStatus: "Status",
    tenantActive: "Active tenant",
    roleAdmin: "admin role",
    roleMember: "member role",
    hello: "Hello",
    sectionClient: "Client invoices",
    sectionSupplier: "Supplier invoices",
    kpiSupplierPending: "To pay (suppliers)",
    kpiSupplierPendingHint: "Total outstanding supplier invoices (incl. tax)",
    kpiSupplierPaid: "Paid this month (suppliers)",
    kpiSupplierPaidHint: "Sum of supplier payments made this month",
  
    currencyLabel: "Currency:",
    currencyAll: "All*",
    currencyWarning: "* Currencies are not consolidated — select a currency to see exact KPIs.",
  },
  invoicesPage: {
    title: "Invoices",
    subtitle: "Track and manage all your invoices.",
    markPaid: "Mark as paid",
    markPaidTitle: "Mark as paid",
    markPaidConfirm: "Confirm payment",
    paymentDate: "Payment date",
    newInvoice: "New invoice",
    open: "Open",
    filterStatus: "Status",
    filterClient: "Client",
    filterProject: "Project",
    filterIntervenant: "Worker",
    allStatuses: "All statuses",
    allClients: "All clients",
    allProjects: "All projects",
    allIntervenants: "All workers",
    previous: "Previous",
    next: "Next",
    exportXlsx: "Export XLSX",
    exporting: "Exporting…",
    colIssued: "Sent",
    colTTC: "Total",
    colReste: "Balance",
    issuePeriod: "Issue period",
    delete: "Delete",
    deleteConfirm: "Permanently delete invoice",
    deleteWarning: "This action is irreversible.",
      colRef: "Reference",
      colDue: "Due",
      searchPlaceholder: "Search (reference)…",
      reset: "Reset",
    search: "Search",
    noMatch: "No invoices match these criteria.",
    loadingList: "Loading…",
    colClient: "Client",
  },
  invoiceDetail: {
    title: "Invoice",
    back: "← Back to portfolio",
    backToList: "← Back to list",
    deleteInvoice: "Delete this invoice",
    deleteConfirm: "Delete this invoice? This action is irreversible.",
    addPayment: "+ Payment",
    paymentAmount: "Amount",
    paymentDate: "Payment date",
    paymentMethod: "Method",
    paymentNote: "Note (optional)",
    paymentRef: "Reference (transfer no., cheque…)",
    paymentConfirm: "Record payment",
    paymentCancel: "Cancel",
    paymentSaving: "Saving…",
    paymentsHistory: "Payment history",
    noPayments: "No payments recorded yet.",
    sendReminder: "Send reminder",
    generateLink: "Generate payment link",
    generateZiina: "Generate Ziina link",
    regenerateZiina: "Regenerate link",
    copyLink: "Copy link",
    linkCopied: "Link copied!",
    generating: "Generating…",
    regenerating: "Regenerating…",
    downloadPdf: "View PDF",
    downloadPdfEn: "View PDF (EN)",
    downloadPdfFr: "View PDF (FR)",
    duplicate: "Duplicate",
    statusLabel: "Status",
    amountHT: "Amount (excl. tax)",
    amountTTC: "Amount (incl. tax)",
    dueDate: "Due date",
    issueDate: "Issue date",
    remaining: "Remaining",
    totalTtc: "TOTAL",
    collected: "COLLECTED",
    remainingDue: "BALANCE DUE",
    issuedOn: "Issued on",
    dueOn: "Due",
    backToDraft: "↩ Back to draft",
    validateIssue: "✓ Validate & issue invoice",
    saveDraft: "Save changes",
    saving: "Saving…",
    draftTitle: "Draft invoice — to complete",
    draftHint: "Assign a project and worker, adjust the amount if needed, then validate.",
    draftProject: "Project",
    draftNoProject: "— No project —",
    draftIntervenant: "Worker",
    draftNoIntervenant: "— No worker —",
    draftDueDate: "Due date",
    draftCurrency: "Currency",
    draftBilling: "Billing",
    draftBillingFull: "Full quote amount",
    draftBillingPercent: "Percentage of quote",
    draftBillingQty: "By quantity (quote lines)",
    draftBillingAmount: "Custom amount",
    draftPercent: "Percentage to invoice (%)",
    draftAmountHt: "Amount excl. tax (€)",
    draftVat: "VAT (€)",
    draftAmountTtc: "Total incl. tax (€)",
    notesPlaceholder: "No notes for this invoice.",
    saveNote: "Save note",
    paymentLinkTitle: "Online payment link",
    paymentLinkDesc: "Your client pays the invoice by card via Ziina. Paste the link in an email or copy it here.",
    paymentLinkNotAvailable: "This invoice is not in a payable state — no link available.",
    paymentLinkUrl: "Payment URL",
    paymentLinkGeneratedAt: "Generated on",
    paymentLinkExpiresAt: "Expires on",
    paymentLinkExpired: "(expired)",
    remindersTitle: "Reminders",
    remindersSubtitle: "Automatic sends at D+7, D+14 and D+30 after the due date.",
    remindersDisabled: "Reminders disabled",
    remindersReason: "Reason:",
    reactivateReminders: "Re-enable reminders",
    disableReminders: "Stop reminders",
    noReminders: "No reminders sent yet.",
    disableReminderTitle: "Stop reminders for this invoice",
    disableReminderDesc: "No automatic reminder will be sent for this invoice while disabled. You can re-enable at any time.",
    disableReminderReason: "Reason (kept for audit)",
    disableReminderReasonPlaceholder: "E.g.: amicable agreement signed, client in liquidation, duplicate…",
    disableReminderConfirm: "Disable reminders",
    paymentSuccess: "Thank you — payment confirmed on Ziina's side. The payment will appear here once bank confirmation is received.",
    paymentCancelled: "Payment cancelled. The link remains valid if you wish to try again.",
    close: "Close",
    reminderStatusPending: "Pending",
    reminderStatusSent: "Sent",
    reminderStatusFailed: "Failed",
    reminderStatusSkipped: "Skipped",
    paymentMethodBankTransfer: "Bank transfer",
    paymentMethodCheck: "Cheque",
    paymentMethodCash: "Cash",
    paymentMethodCard: "Card",
    paymentMethodOther: "Other",
    colDate: "Date",
    colMethod: "Method",
    colRef: "Reference",
    colAmount: "Amount",
    loadingError: "Failed to load",
    notFound: "Invoice not found",
    validating: "Validating and issuing…",
    actionImpossible: "Action impossible",
    colRecipient: "Recipient",
    colTemplate: "Template",
    colStatus: "Status",
    draftQtyLabel: "Quantities to invoice per line",
    draftQtyTotal: "Calculated total incl. tax:",
    draftPercentTtc: "Calculated total incl. tax:",
  },
  clientsPage: {
    title: "Clients",
    subtitle: "Entities billed by the active tenant.",
    newClient: "New client",
    searchPlaceholder: "Search (name or email)…",
    noClients: "No clients yet. Click \"New client\" to get started.",
    deleteConfirm: 'Delete client "{name}"?',
    editClient: "Edit client",
    newClientTitle: "New client",
    legalName: "Legal name",
    siret: "SIRET",
    vatNumber: "VAT number",
    countryHint: "E.g.: FR, AE",
    caByClient: "Revenue breakdown by client",
  },
  projectsPage: {
    title: "Projects",
    subtitle: "Group your invoices by project.",
    newProject: "New project",
    noProjects: "No projects yet.",
    editProject: "Edit project",
    newProjectTitle: "New project",
    deleteConfirm: 'Delete project "{name}"?',
    caByProject: "Revenue breakdown by project",
    description: "Description",
    nbInvoices: "Invoices",
    caTotal: "Total revenue",
    collected: "Collected",
    pending: "Pending",
    filterByClient: "Filter by client:",
    allClients: "All clients",
    noClients: "Create a client first before creating projects.",
  },
  intervenantsPage: {
    title: "Workers",
    subtitle: "People who perform the billed services.",
    newIntervenant: "New worker",
    noIntervenants: "No workers yet.",
    editIntervenant: "Edit worker",
    newIntervenantTitle: "New worker",
    deleteConfirm: 'Delete worker "{name}"?',
    caByIntervenant: "Revenue breakdown by worker",
    active: "Active",
    inactive: "Inactive",
    activeOnly: "Active only",
    monthlyAnalysis: "Monthly analysis",
    allIntervenants: "All",
    allMonths: "All months",
    nbInvoices: "Invoices",
    caTotal: "Total revenue",
    collected: "Collected",
    pending: "Pending",
    caGenerated: "Total revenue generated",
    caPaid: "Collected revenue",
  },
  billingPage: {
    title: "Billing",
    subtitle: "Subscription and payment history.",
    currentPlan: "Current plan",
    invoiceHistory: "Invoice history",
    noBillingInvoices: "No subscription invoices yet.",
    downloadPdf: "PDF",
    downloadError: "Download error",
    planActive: "Active",
    planExpires: "Expires on",
    noSubscription: "No active subscription.",
    noSubscriptionTitle: "No subscription",
    noSubscriptionDesc: "You have not yet subscribed to an Hsasoft plan. Choose your plan to activate billing and continue using HInvoice beyond your trial period.",
    choosePlan: "Choose a plan",
    cancelAtPeriodEnd: "Cancel at end of period",
    cancelScheduled: "Cancellation scheduled for",
    perMonth: "/ month",
  },

  auditPage: {
    title: "Audit log",
    subtitle: "History of actions in your workspace.",
    noEvents: "No events.",
    colDate: "Date",
    colUser: "User",
    colAction: "Action",
    colResource: "Resource",
  },
  reconciliationPage: {
    title: "Reconciliation",
    subtitle: "Match received payments to invoices.",
    noItems: "Nothing to reconcile.",
    reconcile: "Reconcile",
    ignore: "Ignore",
  },
  uploadsPage: {
    title: "Received invoices",
    subtitle: "Import and analyse your supplier invoices.",
    upload: "Import",
    noUploads: "No invoices imported.",
    processing: "Processing…",
    colFile: "File",
    colDate: "Date",
    colStatus: "Status",
    colActions: "Actions",
  },
  reminderRulesPage: {
    title: "Reminder rules",
    subtitle: "Configure your automatic reminders.",
    newRule: "New rule",
    noRules: "No rules configured.",
    deleteConfirm: "Delete this rule?",
    editRule: "Edit rule",
    colName: "Name",
    colTrigger: "Trigger",
    colTemplate: "Template",
    colActive: "Active",
  },
  reminderTemplatesPage: {
    title: "Reminder templates",
    subtitle: "Write your reminder email templates.",
    newTemplate: "New template",
    noTemplates: "No templates.",
    deleteConfirm: "Delete this template?",
    editTemplate: "Edit template",
    colName: "Name",
    colSubject: "Subject",
    colLang: "Language",
  },
  trialBanner: {
    trialEnds: "Your trial ends on",
    subscribe: "Subscribe",
    expired: "Your trial has expired.",
  },
  loginPage: {
    title: "Sign in",
    email: "Email",
    password: "Password",
    submit: "Sign in",
    loading: "Signing in…",
    noAccount: "Don't have an account?",
    signup: "Create a tenant",
  },
  signupPage: {
    title: "Create a tenant",
    fullName: "Your full name",
    email: "Email",
    password: "Password",
    passwordHint: "Minimum 10 characters",
    companyLong: "Company name",
    slug: "Slug (URL identifier)",
    slugHint: "letters, numbers, hyphens — e.g. hsasoft",
    language: "Langue / Language",
    submit: "Create account",
    loading: "Creating…",
    haveAccount: "Already have an account?",
    login: "Sign in",
    trialHint: "You are starting a 14-day trial. You can upgrade to the {{plan}} plan at any time from the pricing page.",
    errorDefault: "Failed to create account",
  },

  uploadsPage: {
    title: "Received invoices",
    subtitle: "Upload a PDF, let OCR extract the fields, then validate.",
    upload: "Import a PDF",
    tabReview: "To review",
    tabProcessing: "Processing",
    tabErrors: "Errors",
    tabValidated: "Validated",
    colFile: "File",
    colSize: "Size",
    colDate: "Received",
    noUploads: "No invoices imported.",
    processing: "Processing…",
  },
  reconciliationPage: {
    title: "Bank reconciliation",
    subtitle: "Import a bank CSV, match each credit to an invoice.",
    importCsv: "Import CSV",
    formats: "Formats: FR Bank (Label, Amount) or EN. Debits ignored.",
    reconcile: "Reconcile",
    ignore: "Ignore",
    noItems: "Nothing to reconcile.",
  },
  membersPage: {
    title: "Team",
    subtitle: "Manage members of this tenant. At least one admin must remain.",
    invite: "Invite member",
    joinedAt: "Join",
    lastLogin: "Last connexion",
    you: "you",
    remove: "Remove",
    pendingTitle: "Pending invitations",
    pendingDesc: "The recipient receives an email with a link valid for 7 days.",
    noPending: "No pending invitations.",
    roleAdmin: "Administrator",
    roleMember: "Member",
  
    accepted: "Accepted",
    hintAdmin: "Full access, member management",
    hintComptable: "Invoices, payments, reminders",
    hintViewer: "Read only",
    inviteRole: "Role",
    proposedRole: "Proposed role",
    inviteSent: "Invitation sent to",
    deleteConfirm: "Remove this member?",
    roleViewer: "Observer",
    revokeConfirm: "Cancel invitation for {email}?",
    noMembers: "No members.",
    roleComptable: "Accountant",
    pending: "Pending",
    inviteEmail: "Email",
    colName: "Name",
    colRole: "Role",
    colJoined: "Joined on",
    colLastLogin: "Last login",
    colSent: "Sent on",
    colExpiry: "Expiry",
    expiresInDays: "expires in {n} d",
    expiresInHours: "expires in {n} h",
    expired: "expired",
    expiresSoon: "soon",
  },
  reminderRulesPage: {
    title: "Reminder rules",
    subtitle: "Configure when and how to remind your clients.",
    newRule: "New rule",
    editRule: "Edit rule",
    noRules: "No rules configured.",
    colTrigger: "Trigger",
    colTemplate: "Template",
    colOrder: "Order",
    colActive: "Active",
    deleteConfirm: "Delete this rule?",
  },
  reminderTemplatesPage: {
    title: "Reminder templates",
    subtitle: "Customize your automatic reminder emails.",
    newTemplate: "New template",
    editTemplate: "Edit template",
    noTemplates: "No templates.",
    deleteConfirm: "Delete this template?",
    emailSubject: "Email subject",
    emailBody: "Body (text)",
    key: "Key",
  },
  suppliersPage: {
    title: "Suppliers",
    subtitle: "Expenses and supplier invoices",
    chartTitle: "Expenses by supplier",
    searchPlaceholder: "Search supplier invoices…",
    noInvoices: "No supplier invoices. Import a PDF with type \"Supplier\".",
    supplier: "Supplier",
    colRef: "Reference",
    colDate: "Date",
    colDue: "Due date",
    colTtc: "Total",
    colStatus: "Status",
  },
  salesPage: {
    title: "Sales",
    subtitle: "Manage your quotes and commercial offers.",
    newQuote: "New Quote",
    colRef: "Reference",
    colClient: "Client",
    colIntervenant: "Worker",
    colAmount: "Total (incl. tax)",
    colExpiry: "Expiry",
    colStatus: "Status",
    allStatuses: "All statuses",
    statusDraft: "Draft",
    statusSent: "Sent",
    statusAccepted: "Accepted",
    statusDeclined: "Declined",
    statusCancelled: "Cancelled",
    statusInvoiced: "Invoiced",
    editQuote: "Edit quote",
    createQuote: "New quote",
    client: "Client",
    intervenant: "Worker",
    issueDate: "Issue date",
    expiryDate: "Expiry date",
    paymentTerms: "Payment terms",
    notes: "Notes",
    lines: "Lines",
    lineDescription: "Description",
    lineQty: "Qty",
    lineUnitPrice: "Unit price",
    lineVat: "VAT %",
    lineUnit: "Unit",
    lineAmountHT: "Excl. tax",
    addLine: "Add line",
    totalHT: "Subtotal",
    totalVAT: "VAT",
    totalTTC: "Total",
    send: "Send",
    toInvoice: "Convert to invoice",
    sendConfirm: "Mark this quote as sent?",
    toInvoiceConfirm: "Create an invoice from this quote?",
    deleteConfirm: "Delete this quote?",
    invoiceCreated: "Invoice created successfully",
    noQuotes: "No quotes yet.",
    selectClient: "Select a client",
    selectIntervenant: "Select a worker (optional)",
    downloadPdf: "Download PDF",
    ptSelect: "— Select —",
    pt0: "0 day (immediate payment)",
    pt30: "30 days",
    pt45: "45 days",
    pt60: "60 days",
    pt90: "90 days",
    downloadPdfEn: "PDF EN",
    duplicate: "Duplicate",
      project: "Project",
      selectProject: "Select a project (optional)",
    currency: "Currency",
    currencyHint: "EUR, AED or USD",
      accept: "Accept",
      decline: "Decline",
      declineConfirm: "Mark this quote as declined?",
    discountTitle: "Commercial discount",
    discountType: "Discount type",
    discountNone: "— No discount —",
    discountPercent: "Percentage (%)",
    discountFixed: "Fixed amount ({currency})",
    discountLabelPercent: "Discount (%)",
    discountLabelFixed: "Discount excl. tax ({currency})",
    discountPlaceholderPercent: "e.g. 10",
    discountPlaceholderFixed: "e.g. 500",
    grossSubtotal: "Gross subtotal (excl. tax)",
    discountLine: "Discount",
  },
  companySettings: {
    title: "Company Information",
    subtitle: "These details appear on your quotes and invoices.",
    identity: "Identity",
    companyName: "Company name",
    email: "Contact email",
    phone: "Phone",
    website: "Website",
    address: "Address",
    addressLine1: "Address line 1",
    addressLine2: "Address line 2",
    postalCode: "Postal code",
    city: "City",
    country: "Country",
    legal: "Legal information",
    siret: "SIRET / Licence",
    vatNumber: "VAT / Tax number",
    logo: "Logo",
    logoHint: "PNG, JPG or SVG format. Max 2 MB.",
    changeLogo: "Change logo",
    bank: "Bank details",
    bankName: "Bank",
    iban: "IBAN",
    bic: "BIC / SWIFT",
    legalFooter: "Legal footer",
    legalFooterHint: "Appears at the bottom of quotes and invoices.",
    saved: "Settings saved.",
    saveError: "Error saving settings.",
    logoUploaded: "Logo updated.",
    logoError: "Error uploading logo.",
    defaultVatRate: "Default VAT rate (%)",
    vatRateHint: "E.g. 5 for UAE, 20 for France",
    currency: "Default currency",
    currencyHint: "Applied to new invoices by default",
  },

  footer: {
    copyright: "All rights reserved.",
    legalLink: "Legal Notice",
    contact: "Contact",
  },
  legal: {
    title: "Legal Notice",
    subtitle: "HInvoice — published by Hsasoft",
    editorTitle: "Service Publisher",
    company: "Company",
    product: "Product",
    licence: "Licence number",
    address: "Registered address",
    addressValue: "DIP Falcon House, Dubai, United Arab Emirates",
    email: "Contact email",
    hostingTitle: "Hosting",
    hostingText: "HInvoice is hosted on Hostinger VPS servers, operated by Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Cyprus.",
    ipTitle: "Intellectual Property",
    ipText: "All content on HInvoice (texts, images, logos, interfaces, software) is the exclusive property of Hsasoft or its partners, and is protected by applicable intellectual property laws. Any reproduction, distribution or use without prior authorisation is prohibited.",
    dataTitle: "Personal Data",
    dataText: "HInvoice collects and processes personal data to provide its service (account management, billing, email notifications). This data is stored securely and is never shared with third parties without explicit consent.",
    dataText2: "In accordance with applicable regulations, you have the right to access, rectify and delete your data. To exercise these rights, contact us at",
    liabilityTitle: "Limitation of Liability",
    liabilityText: "Hsasoft strives to ensure the accuracy and currency of information on HInvoice. However, Hsasoft cannot be held liable for errors or omissions, nor for direct or indirect damages resulting from use of the service.",
    lawTitle: "Applicable Law",
    lawText: "These legal notices are governed by the laws of the United Arab Emirates. Any dispute relating to their interpretation or execution falls under the exclusive jurisdiction of the competent courts of Dubai.",
    updated: "Last updated: May",
    backLink: "← Back to the application",
  },
  productsPage: {
    title: "Products",
    subtitle: "Manage your product and service catalogue.",
    newProduct: "New product",
    searchPlaceholder: "Search by name...",
    colRef: "Reference",
    colName: "Name",
    colDescription: "Description",
    colSalePriceHT: "Sale price (excl. tax)",
    colVat: "VAT %",
    colSalePriceTTC: "Sale price (incl. tax)",
    colPurchasePrice: "Purchase price",
    colCurrency: "Currency",
    colUnit: "Unit",
    colActions: "Actions",
    editProduct: "Edit product",
    createProduct: "New product",
    name: "Name",
    reference: "Reference",
    description: "Description",
    salePriceHT: "Sale price HT",
    vatRate: "VAT rate (%)",
    salePriceTTC: "Sale price TTC",
    purchasePrice: "Purchase price (optional)",
    currency: "Currency",
    unit: "Unit (e.g. h, day, item)",
    archive: "Archive",
    archiveConfirm: "Archive this product?",
    noProducts: "No products yet.",
    addToQuote: "Add product to quote",
    selectProduct: "Select a product (optional)",
  },
} as const;

export default en;
